module.exports = "<a ui-sref=\"proyecto.documentos.plantilla({id_plantilla: $ctrl.data.id_plantilla, version: $ctrl.data.version})\">\r\n  <div class=\"kd-item padding-md card-hoverable\">\r\n    <div>\r\n      <i class=\"fa fa-fw\" ng-repeat=\"item in ::$ctrl.nivel track by $index\"></i>\r\n      <i class=\"fa fa-fw fa-file-pdf-o\"></i>\r\n    </div>\r\n    <div class=\"flex\">\r\n      {{::$ctrl.data.nombre}}\r\n    </div>\r\n  </div>\r\n</a>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/fan/proyecto/components/documentos/plantillas/lista/item-archivo/template.html
// module id = 570
// module chunks = 0